import { useProfile } from '@/lib/queries/profile';

const ADMIN_ROLE = 'ADMIN';

export function useIsAdmin(): boolean {
  const { data } = useProfile();
  return data?.roles?.includes(ADMIN_ROLE) ?? false;
}
